<script>
import { mapGetters } from 'vuex';

import InvoiceService from "@/store/services/invoice.service.js";
import QuotationService from "@/store/services/quotation.service";
import TotalAmountsBase from "@/components/base_components/TotalAmountsBase.vue";

export default {
  name: "TotalAmountsInvoices",
  extends: TotalAmountsBase,
  props: {
    quotationAmounts: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      mutationName: 'filterStore/SET_UPDATE_FILTER_INVOICES'
    }
  },
  computed: {
    ...mapGetters({ 
      currentCompany: "main/getCurrentCompany",
      getCompanyId: 'main/getCompanyId'
    }),
  },
  methods: {
    getTotalAmounts(){
      if(Object.keys(this.filters).length !== 0){
        this.loading = true
        if(!this.filters.owner_company){
          this.filters.owner_company = this.getCompanyId;
        }
        if (!this.quotationAmounts) {
          InvoiceService.totalAmounts(this.filters).then((response) => {
            this._processTotals(response.data)
          })
        } else {
          QuotationService.totalAmounts(this.filters).then((response) => {
            this._processTotals(response.data)
          });
        }
      }
    },
    _processTotals(totals) {
      this.loading = false
      this.amountsList = [];
      this.amountsList.push({text: this.$gettext("NET"), amount: totals['total_net'], class:'text-brand'});
      this.amountsList.push({text: this.$gettext("VAT"), amount: totals['total_vat'], class:'text-blue'});
      if(this.currentCompany.country === 'ES'){
        this.amountsList.push({text: this.$gettext("IRPF"), amount: totals['total_retention_tax'], class:'text-uninvoiced'});
      }
      this.amountsList.push({text: this.$gettext("TOTAL"), amount: totals['total'], class:''});
    }
  }
};
</script>